export interface ConditionEntry {
  key: string;
  label: string;
  /** Extra tokens that improve search matching (no diacritics, common abbreviations). */
  aliases?: string[];
}

export const CONDITIONS_CATALOG: ConditionEntry[] = [
  // ── Ortopedia ────────────────────────────────────────────────────────────
  { key: 'luxacion_rotula', label: 'Luxación de rótula', aliases: ['luxa', 'rotula', 'rodilla', 'luxacion'] },
  { key: 'displasia_cadera', label: 'Displasia de cadera', aliases: ['cadera', 'displasia'] },
  { key: 'displasia_codo', label: 'Displasia de codo', aliases: ['codo', 'displasia'] },
  { key: 'rotura_lca', label: 'Rotura del ligamento cruzado', aliases: ['cruciate', 'lca', 'ligamento', 'rodilla'] },
  { key: 'osteocondritis', label: 'Osteocondritis (OCD)', aliases: ['ocd', 'osteocondritis', 'cartilago'] },
  { key: 'espondilosis', label: 'Espondilosis', aliases: ['columna', 'espondilosis', 'vertebra'] },
  { key: 'hernia_discal', label: 'Hernia discal (IVDD)', aliases: ['hernia', 'disco', 'ivdd', 'intervertebral'] },
  { key: 'mielopatia', label: 'Mielopatía degenerativa', aliases: ['mielopatia', 'degenerativa', 'columna'] },
  { key: 'osteoartritis', label: 'Osteoartritis', aliases: ['artritis', 'osteoartritis'] },

  // ── Dermatología ─────────────────────────────────────────────────────────
  { key: 'atopia', label: 'Atopia / dermatitis atópica', aliases: ['atopia', 'atopica', 'picor', 'dermato'] },
  { key: 'dermatitis_contacto', label: 'Dermatitis por contacto', aliases: ['dermato', 'contacto', 'alergia'] },
  { key: 'sarna_sarcoptica', label: 'Sarna sarcóptica', aliases: ['sarna', 'sarcoptica', 'mange'] },
  { key: 'sarna_demodectica', label: 'Sarna demodéctica', aliases: ['sarna', 'demodex', 'demodectica'] },
  { key: 'tina', label: 'Tiña (dermatofitosis)', aliases: ['tina', 'hongo', 'dermatofitosis'] },
  { key: 'foliculitis', label: 'Foliculitis bacteriana', aliases: ['foliculitis', 'bacteria', 'piel'] },
  { key: 'lupus', label: 'Lupus eritematoso', aliases: ['lupus', 'autoinmune'] },
  { key: 'pemfigo', label: 'Pénfigo', aliases: ['pemfigo', 'autoinmune', 'ampolla'] },

  // ── Endocrinología ───────────────────────────────────────────────────────
  { key: 'hipotiroidismo', label: 'Hipotiroidismo', aliases: ['tiroides', 'hipotiroid'] },
  { key: 'hipertiroidismo', label: 'Hipertiroidismo', aliases: ['tiroides', 'hipertiroid'] },
  {
    key: 'cushing',
    label: 'Hiperadrenocorticismo (Cushing)',
    aliases: ['cushing', 'cortisol', 'adrenal', 'hiperadrenocorticismo'],
  },
  { key: 'addison', label: 'Hipoadrenocorticismo (Addison)', aliases: ['addison', 'adrenal', 'hipoadrenocorticismo'] },
  { key: 'diabetes_insipida', label: 'Diabetes insípida', aliases: ['diabetes', 'insipida', 'polidipsia'] },

  // ── Digestivo ────────────────────────────────────────────────────────────
  { key: 'megaesofago', label: 'Megaesófago', aliases: ['megaesofago', 'esofago', 'regurgitacion'] },
  {
    key: 'eii',
    label: 'Enfermedad inflamatoria intestinal (EII)',
    aliases: ['eii', 'ibd', 'intestinal', 'inflamatorio'],
  },
  { key: 'colitis', label: 'Colitis', aliases: ['colitis', 'intestino', 'diarrea'] },
  {
    key: 'gastroenteritis_cronica',
    label: 'Gastroenteritis crónica',
    aliases: ['gastro', 'estomago', 'diarrea', 'vomito'],
  },
  { key: 'ulcera_gastrica', label: 'Úlcera gástrica', aliases: ['ulcera', 'gastrica', 'estomago'] },
  { key: 'estenosis_pilorica', label: 'Estenosis pilórica', aliases: ['estenosis', 'pilorica', 'piloro'] },
  {
    key: 'shunt_portosistemico',
    label: 'Shunt portosistémico',
    aliases: ['shunt', 'portosistemico', 'higado', 'hepático'],
  },
  { key: 'ascitis', label: 'Ascitis', aliases: ['ascitis', 'liquido', 'abdomen'] },

  // ── Urinario ─────────────────────────────────────────────────────────────
  {
    key: 'urolitiasis',
    label: 'Urolitiasis (cálculos urinarios)',
    aliases: ['calculos', 'urinarios', 'piedras', 'urolitiasis', 'riñon'],
  },
  { key: 'cistitis_cronica', label: 'Cistitis crónica', aliases: ['cistitis', 'vejiga', 'orina'] },
  { key: 'incontinencia', label: 'Incontinencia urinaria', aliases: ['incontinencia', 'pis', 'orina'] },
  { key: 'pielonefritis', label: 'Pielonefritis', aliases: ['pielonefritis', 'riñon', 'infeccion'] },
  { key: 'sindrome_fanconi', label: 'Síndrome de Fanconi', aliases: ['fanconi', 'riñon', 'tubulopatia'] },

  // ── Respiratorio ─────────────────────────────────────────────────────────
  {
    key: 'braquicefalico',
    label: 'Síndrome braquicefálico',
    aliases: ['braqui', 'braquicefalico', 'brachycephalic', 'ronquido'],
  },
  { key: 'colapso_traqueal', label: 'Colapso traqueal', aliases: ['traquea', 'colapso', 'tos'] },
  { key: 'bronquitis_cronica', label: 'Bronquitis crónica', aliases: ['bronquitis', 'tos', 'pulmones'] },
  { key: 'neumonia_aspiracion', label: 'Neumonía por aspiración', aliases: ['neumonia', 'aspiracion', 'pulmones'] },
  { key: 'edema_pulmonar', label: 'Edema pulmonar', aliases: ['edema', 'pulmonar', 'pulmones'] },

  // ── Neurológico ──────────────────────────────────────────────────────────
  { key: 'hidrocefalia', label: 'Hidrocefalia', aliases: ['hidrocefalia', 'cabeza', 'cerebro'] },
  { key: 'sindrome_vestibular', label: 'Síndrome vestibular', aliases: ['vestibular', 'equilibrio', 'mareo'] },
  { key: 'wobbler', label: 'Síndrome de Wobbler', aliases: ['wobbler', 'columna', 'cervical', 'inestabilidad'] },
  { key: 'neuropatia_periferica', label: 'Neuropatía periférica', aliases: ['neuropatia', 'nervio', 'periferica'] },

  // ── Cardiovascular ───────────────────────────────────────────────────────
  {
    key: 'endocardiosis_mitral',
    label: 'Endocardiosis mitral (valvular)',
    aliases: ['mitral', 'valvula', 'corazon', 'endocardiosis'],
  },
  { key: 'cardiomiopatia_dilatada', label: 'Cardiomiopatía dilatada', aliases: ['cardiomiopatia', 'dcm', 'corazon'] },
  { key: 'insuficiencia_cardiaca', label: 'Insuficiencia cardíaca', aliases: ['insuficiencia', 'corazon', 'cardiaca'] },

  // ── Ocular ───────────────────────────────────────────────────────────────
  { key: 'cataratas', label: 'Cataratas', aliases: ['cataratas', 'ojo', 'vision'] },
  { key: 'glaucoma', label: 'Glaucoma', aliases: ['glaucoma', 'ojo', 'presion'] },
  {
    key: 'ojo_seco',
    label: 'Queratoconjuntivitis seca (ojo seco)',
    aliases: ['ojo seco', 'kcs', 'lagrima', 'queratoconjuntivitis'],
  },
  { key: 'ulcera_corneal', label: 'Úlcera corneal', aliases: ['ulcera', 'cornea', 'ojo'] },
  { key: 'distrofia_corneal', label: 'Distrofia corneal', aliases: ['distrofia', 'cornea', 'ojo'] },

  // ── Inmunológico / Sistémico ─────────────────────────────────────────────
  { key: 'leishmaniasis', label: 'Leishmaniasis', aliases: ['leishmania', 'leishmaniasis'] },
  { key: 'ehrlichiosis', label: 'Ehrlichiosis', aliases: ['ehrlichia', 'garrapata'] },
  {
    key: 'anemia_hemolitica',
    label: 'Anemia hemolítica inmunomediada (AHIM)',
    aliases: ['ahim', 'anemia', 'hemolitica', 'autoinmune'],
  },
  {
    key: 'trombocitopenia',
    label: 'Trombocitopenia inmunomediada',
    aliases: ['trombocito', 'plaquetas', 'autoinmune'],
  },
  { key: 'linfoma', label: 'Linfoma', aliases: ['linfoma', 'ganglios', 'cancer', 'tumor'] },
  { key: 'mastocitoma', label: 'Mastocitoma', aliases: ['mastocitoma', 'mast cell', 'tumor'] },
  { key: 'osteosarcoma', label: 'Osteosarcoma', aliases: ['osteosarcoma', 'hueso', 'cancer'] },
  { key: 'hemangiosarcoma', label: 'Hemangiosarcoma', aliases: ['hemangiosarcoma', 'bazo', 'cancer'] },

  // ── Reproductivo ─────────────────────────────────────────────────────────
  { key: 'piometra', label: 'Piómetra', aliases: ['piometra', 'utero', 'infeccion'] },
  { key: 'hiperplasia_prostatica', label: 'Hiperplasia prostática', aliases: ['prostata', 'hiperplasia'] },

  // ── Metabólico ───────────────────────────────────────────────────────────
  { key: 'hipoglucemia', label: 'Hipoglucemia', aliases: ['glucosa', 'azucar', 'hipoglucemia'] },
  { key: 'hipoalbuminemia', label: 'Hipoalbuminemia', aliases: ['albumina', 'proteinas', 'hipoalbuminemia'] },
  {
    key: 'portoencefalopatia',
    label: 'Portoencefalopatía hepática',
    aliases: ['portoe', 'higado', 'amoniaco', 'encefalopatia'],
  },

  // ── Otro ─────────────────────────────────────────────────────────────────
  { key: 'ansiedad_separacion', label: 'Ansiedad por separación', aliases: ['ansiedad', 'separacion', 'estres'] },
  {
    key: 'epilepsia_reactiva',
    label: 'Epilepsia reactiva / fotosensible',
    aliases: ['epilepsia', 'convulsion', 'fotosensible'],
  },
  { key: 'hipoplasia_esmalte', label: 'Hipoplasia de esmalte', aliases: ['esmalte', 'dientes', 'dental'] },
];

/** Busca condiciones que coincidan con la query (case-insensitive, sin acentos). */
export function searchConditions(query: string): ConditionEntry[] {
  const q = normalize(query);
  if (q.length < 2) return [];
  return CONDITIONS_CATALOG.filter((c) => {
    if (normalize(c.label).includes(q)) return true;
    return c.aliases?.some((a) => normalize(a).includes(q));
  }).slice(0, 8);
}

function normalize(s: string): string {
  return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
}
